import { Pipe, PipeTransform } from '@angular/core';
import { CaseName } from '@store/models';

@Pipe({
    name: 'caseName',
    standalone: false
})
export class CaseNamePipe implements PipeTransform {
    transform(caseNames: CaseName[], sagId: number): CaseName {
        return caseNames?.find(sag => sag.pid === sagId);
    }
}
